import { ProductTypePayload } from "infrastructure/services";

export const productTypeParamName = "productType";
export const affinityParamName = "affinity";
export const accountParamName = "accountType";
export const productDefault = "default";

export interface ProductType {
  isAhorro?: boolean;
  isCredito?: boolean;
  isPymes?: boolean;
  isSalaryAccount?: boolean;
  isCollegePack?: boolean;
}

export enum ProductTypeQueryParam {
  CreditParam = "OBT", // Credit Card
  AccountParam = "OBD", // Personal account
  PymesParam = "OBP", // Pymes Account
  SalaryAccount = "OBC", // Salary Account
  CollegePack = "OBX", // College Pack
  default = "default",
}

export const productTypeParamToPayload = (
  productTypeParam: ProductTypeQueryParam
): ProductTypePayload => {
  switch (productTypeParam) {
    case ProductTypeQueryParam.CreditParam:
      return ProductTypePayload.CREDIT_CARD;
    case ProductTypeQueryParam.PymesParam:
      //TODO: RETURN CORRECT PAYLOAD AFTER BACKEND GETS DEPLOYED
      return ProductTypePayload.ACCOUNT_PYME;
    case ProductTypeQueryParam.SalaryAccount:
      //TODO: RETURN CORRECT PAYLOAD AFTER BACKEND GETS DEPLOYED
      return ProductTypePayload.SALARY_ACCOUNT;
    case ProductTypeQueryParam.CollegePack:
      return ProductTypePayload.COLLEGE_PACK;
    default:
      return ProductTypePayload.ACCOUNT;
  }
};
